module.exports = __webpack_public_path__ + "img/Unicorn-Cake.32aee03a.jpg";